import Vue from 'vue'
import Router from 'vue-router'

import PageNotFound from '@/views/PageNotFound';
import Unauthorised from '@/views/Unauthorised';

import billRoutes from '@/router/routes/bill'
import directoryRoutes from '@/router/routes/directory'
import documentRoutes from '@/router/routes/document'
import fileRoutes from '@/router/routes/file'
import notificationsRoutes from '@/router/routes/notifications'
import paymentRoutes from '@/router/routes/payment'
import restRoutes from '@/router/routes/rest'
import salesRoutes from '@/router/routes/sales'

Vue.use(Router)

// var scrollBehavior = function(to, from, savedPosition) {
var scrollBehavior = function (to) {
  if (to.hash) {
    return {
      selector: to.hash
    }
  } else {
    return {
      x: 0,
      y: 0
    }
  }
};

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    ...billRoutes,
    ...directoryRoutes,
    ...documentRoutes,
    ...fileRoutes,
    ...notificationsRoutes,
    ...paymentRoutes,
    ...restRoutes,
    ...salesRoutes,
    {
      path: '/cashflow/accounts',
      name: 'cashflowAccounts',
      component: () => import( /* webpackChunkName: "cashflowAccounts" */ '@/views/cashflow/Cashflow.vue')
    },
    {
      path: '/cashflow/calendar',
      name: 'cashflowCalendar',
      component: () => import( /* webpackChunkName: "cashflowCalendar" */ '@/views/cashflow/Calendar.vue')
    },
    {
      path: '/cashflow/currencies',
      name: 'cashflowCurrencies',
      component: () => import( /* webpackChunkName: "cashflowCurrencies" */ '@/views/cashflow/Currencies.vue')
    },
    {
      path: '/cashflow/purposes',
      name: 'cashflowPurposes',
      component: () => import( /* webpackChunkName: "cashflowPurposes" */ '@/views/cashflow/Purposes.vue')
    },
    {
      path: '/cashflow/rates',
      name: 'cashflowRates',
      component: () => import( /* webpackChunkName: "cashflowRates" */ '@/views/cashflow/Rates.vue')
    },
    {
      path: '/colps/edit/:id',
      name: 'colp',
      component: () => import( /* webpackChunkName: "colp" */ '@/views/customercare/Colp.vue')
    },
    {
      path: '/colps/list',
      name: 'colps',
      component: () => import( /* webpackChunkName: "colps" */ '@/views/customercare/Colps.vue')
    },
    {
      path: '/emails/diary',
      name: 'emailDiary',
      component: () => import( /* webpackChunkName: "emailDiary" */ '@/views/email/Diary.vue')
    },
    {
      path: '/emailTags',
      name: 'emailTags',
      component: () => import( /* webpackChunkName: "emailTags" */ '@/views/email/EmailTags.vue')
    },
    {
      path: '/emailTags/add',
      name: 'emailTagAdd',
      component: () => import( /* webpackChunkName: "emailTagAdd" */ '@/views/email/EmailTag.vue')
    },
    {
      path: '/emailTags/:id',
      name: 'emailTag',
      component: () => import( /* webpackChunkName: "emailTag" */ '@/views/email/EmailTag.vue')
    },
    {
      path: '/folders/:id',
      name: 'folder',
      component: () => import( /* webpackChunkName: "folder" */ '@/views/message/Folder.vue')
    },
    {
      path: '/folderEdit/:id?',
      name: 'folderEdit',
      component: () => import( /* webpackChunkName: "folderEdit" */ '@/views/message/FolderEdit.vue')
    },
    {
      path: '/folders',
      name: 'folders',
      component: () => import( /* webpackChunkName: "folders" */ '@/views/message/Folders.vue')
    },
    {
      path: '/general/:searchValue',
      name: 'general',
      component: () => import( /* webpackChunkName: "general" */ '@/views/search/General.vue')
    },
    {
      path: '/',
      name: 'home',
      component: () => import( /* webpackChunkName: "home" */ '@/views/Home.vue')
    },
    {
      path: '/imageCollections',
      name: 'imageCollections',
      component: () => import( /* webpackChunkName: "imageCollections" */ '@/views/image/ImageCollections.vue')
    },
    {
      path: '/imageCollections/add',
      name: 'imageCollectionAdd',
      component: () => import( /* webpackChunkName: "imageCollection" */ '@/views/image/ImageCollection.vue')
    },
    {
      path: '/imageCollections/:id',
      name: 'imageCollection',
      component: () => import( /* webpackChunkName: "imageCollection" */ '@/views/image/ImageCollection.vue')
    },
    {
      path: '/imageCollections/:id/images',
      name: 'images',
      component: () => import( /* webpackChunkName: "images" */ '@/views/image/Images.vue')
    },
    {
      path: '/imageCollections/:id/images/add',
      name: 'imageAdd',
      component: () => import( /* webpackChunkName: "image" */ '@/views/image/ImageZ.vue')
    },
    {
      path: '/imageCollections/:id/images/:imageid',
      name: 'image',
      component: () => import( /* webpackChunkName: "image" */ '@/views/image/ImageZ.vue')
    },
    {
      path: '/integer/:searchValue',
      name: 'integer',
      component: () => import( /* webpackChunkName: "integer" */ '@/views/search/Integer.vue')
    },
    {
      path: '/payments/add',
      name: 'paymentAdd',
      component: () => import( /* webpackChunkName: "payment" */ '@/views/fundview/Payment.vue')
    },
    {
      path: '/payments/edit/:id',
      name: 'payment',
      component: () => import( /* webpackChunkName: "payment" */ '@/views/fundview/Payment.vue')
    },
    {
      path: '/payments/diary',
      name: 'paymentsDiary',
      component: () => import( /* webpackChunkName: "paymentsDiary" */ '@/views/fundview/PaymentsDiary.vue')
    },
    {
      path: '/payments/notautolaw',
      name: 'paymentsNotAutolaw',
      component: () => import( /* webpackChunkName: "paymentsNotAutolaw" */ '@/views/fundview/PaymentsNotAutolaw.vue')
    },
    {
      path: '/payments/unallocated',
      name: 'paymentsUnallocated',
      component: () => import( /* webpackChunkName: "paymentsUnallocated" */ '@/views/fundview/PaymentsUnallocated.vue')
    },
    {
      path: '/payments/unsent',
      name: 'paymentsUnsent',
      component: () => import( /* webpackChunkName: "paymentsUnsent" */ '@/views/fundview/PaymentsUnsent.vue')
    },
    {
      path: '/receipts/add',
      name: 'receiptAdd',
      component: () => import( /* webpackChunkName: "receipt" */ '@/views/fundview/Receipt.vue')
    },
    {
      path: '/receipts/edit/:id',
      name: 'receipt',
      component: () => import( /* webpackChunkName: "receipt" */ '@/views/fundview/Receipt.vue')
    },
    {
      path: '/receipts/diary',
      name: 'receiptsDiary',
      component: () => import( /* webpackChunkName: "receiptsDiary" */ '@/views/fundview/ReceiptsDiary.vue')
    },
    {
      path: '/receipts/notautolaw',
      name: 'receiptsNotAutolaw',
      component: () => import( /* webpackChunkName: "receiptsNotAutolaw" */ '@/views/fundview/ReceiptsNotAutolaw.vue')
    },
    {
      path: '/receipts/unclaimed',
      name: 'receiptsUnclaimed',
      component: () => import( /* webpackChunkName: "receiptsUnclaimed" */ '@/views/fundview/ReceiptsUnclaimed.vue')
    },
    {
      path: '/receipts/unverified',
      name: 'receiptsUnverified',
      component: () => import( /* webpackChunkName: "receiptsUnverified" */ '@/views/fundview/ReceiptsUnverified.vue')
    },
    {
      path: '/responses/:id?',
      name: 'response',
      component: () => import( /* webpackChunkName: "response" */ '@/views/message/Response.vue')
    },
    {
      path: '/search/company/:id',
      name: 'searchCompany',
      component: () => import( /* webpackChunkName: "searchCompany" */ '@/views/search/Company.vue')
    },
    {
      path: '/search/existing',
      name: 'searchExisting',
      component: () => import( /* webpackChunkName: "searchExisting" */ '@/views/search/Existing.vue')
    },
    {
      path: '/search/individual/:id',
      name: 'searchIndividual',
      component: () => import( /* webpackChunkName: "searchIndividual" */ '@/views/search/Individual.vue')
    },
    {
      path: '/search/property/:id',
      name: 'searchProperty',
      component: () => import( /* webpackChunkName: "searchProperty" */ '@/views/search/Property.vue')
    },
    {
      path: '/testEmail',
      name: 'testEmail',
      component: () => import( /* webpackChunkName: "testEmail" */ '@/views/message/TestEmail.vue')
    },
    {
      path: '/unauthorised',
      name: 'unauthorised',
      component: Unauthorised,
      meta: {
        noAuth: true
      }
    },
    {
      path: '/unreplied',
      name: 'unreplied',
      component: () => import( /* webpackChunkName: "unreplied" */ '@/views/message/Unreplied.vue')
    },
    {
      path: '*',
      name: 'pageNotFound',
      component: PageNotFound,
      meta: {
        noAuth: true
      }
    }
  ],
  scrollBehavior
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.noAuth)) {
    next()
  } else {
    if (router.app.$keycloak.authenticated) {
      if (router.app.$keycloak.hasRealmRole("general")) {
        // if (to.meta.roles) {
        //   if (router.app.$keycloak.hasRealmRole(to.meta.roles[0])) {
        //     next()
        //   } else {
        //     next({
        //       name: 'unauthorized'
        //     })
        //   }
        // } else {
        next()
        // }
      } else {
        next({
          name: 'unauthorised'
        })
      }
    } else {
      const loginUrl = router.app.$keycloak.createLoginUrl({
        redirectUri: process.env.VUE_APP_MY_URL + to.path
      })
      window.location.replace(loginUrl)
    }
  }
})

export default router